import { createContext } from "react";
import { ActualProtectionTokenFragment } from "gql/graphql";

export const Context = createContext<ActualProtectionTokenFragment[]>([]);
